import { useParams,useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";

const TaskEdit = () => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
   const navigate = useNavigate();
  const [submitStatus, setSubmitStatus] = useState(false);
  const [departments, setDepartment] = useState([]);
  const [multiusers, setMultiUsers] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    employee: "single",
    member: "",
    employees: [],
    priority: "",
    description: "",
    link: "",
    deadline: "",
    files: [],
  });
  const [entries, setEntries] = useState([
    { id: Date.now(), department: "", employee: "", priority: "" },
  ]);
  const [status, setStatus] = useState("");
  const Auth = localStorage.getItem("authToken");
  const Role = parseInt(localStorage.getItem("UserRole"));
  const UserId = parseInt(localStorage.getItem("UserId"));

  useEffect(() => {
    if (id) fetchData();
    fetchEmployeeData();
  }, [id]);

  
  const fetchEmployeeData = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/usersbyadmin", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth}`,
        },
      });
      
const result = await response.json();
      
      if (!response.ok) throw new Error("Failed to fetch users");
      setDepartment(result.data);
      
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  }
  const fetchData = async () => {
    
  try {
    const response = await fetch(
      `https://backend.sanchalansetu.com/api/v1/task-details/group-task/edit/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth}`,
        },
      }
    );
    
    const result = await response.json();
    

    if (!response.ok) throw new Error("Failed to fetch task details");

    const teamMembers = Array.isArray(result?.team_members)
      ? result.team_members
      : [];

    
    const formattedEntries = teamMembers.map((member) => ({
      id: member.task_id || Date.now() + Math.random(),
      department: member.department || "",
      employee: String(member.employee) || "",
      priority:
        member.priority === 2
          ? "High"
          : member.priority === 1
          ? "Intermediate"
          : "Low",
    }));

    
    const formattedDeadline = result.deadline_time
      ? result.deadline_time.replace(" ", "T")
      : "";

    setFormData({
      title: result.title || "",
      employee: "multiple",
      member: "",
      employees: teamMembers.map((m) => String(m.employee)),
      priority: "",
      description: result.description || "",
      link: result.link_if_any || "",
      deadline: formattedDeadline,
      files: [],
    });

    
    setEntries(formattedEntries);

  } catch (err) {
    console.error("Error fetching task data:", err);
    toast.error("Failed to load task data");
  }
};


  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  
  const handleSingleEmployeeChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      member: value,
      employees: value ? [value] : [],
    }));
  };

  
  const handleMultiSelect = (e) => {
    const value = e.target.value;
    setFormData((prev) => {
      const alreadySelected = prev.employees.includes(value);
      return {
        ...prev,
        employees: alreadySelected
          ? prev.employees.filter((id) => id !== value) 
          : [...prev.employees, value], 
      };
    });
  };

 
  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      files: Array.from(e.target.files),
    }));
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus(true);
    try {
      const finalData = {
          ...formData,
          employees: entries,
        };
        
        const fd = new FormData();
        fd.append("title", finalData.title);
        fd.append("description", finalData.description);
        fd.append("deadline", finalData.deadline);
        fd.append("link", finalData.link || "");

        
        finalData.employees.forEach((emp, i) => {
          fd.append(`employees[${i}][department]`, emp.department);
          fd.append(`employees[${i}][employee]`, emp.employee);
          fd.append(`employees[${i}][priority]`, emp.priority);
        });

        
        if (finalData.files && finalData.files.length > 0) {
          finalData.files.forEach((file) => {
            fd.append("files[]", file);
          });
        }
      
      const url = `https://backend.sanchalansetu.com/api/v1/task/edit-group/${id}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth}`,
        },
        body: JSON.stringify(finalData),
      });
      const result = await response.json();
      
      if (response.ok && result.response) {
        toast.success(result.message || "Task updated successfully!");
        setFormData({
            title: "",
            employee: "single",
            member: "",
            employees: [],
            priority: "",
            description: "",
            link: "",
            deadline: "",
            files: [],
          });
          setSubmitStatus(false);
          navigate(`/task-details`);
      } else {
        toast.error(result.message || "Failed to update task");
      }

    } catch (error) {
      console.error("Error updating task:", error);
      setStatus("Error while updating task.");
      toast.error("Error updating task.");
    }
  };

  const addEntry = () => {
    setEntries([
      ...entries,
      { id: Date.now(), department: "", employee: "", priority: "" },
    ]);
  };

  const removeEntry = (id) => {
    setEntries(entries.filter((entry) => entry.id !== id));
  };

  const updateEntry = (id, field, value) => {
    setEntries(
      entries.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };


  return (
    <div className="Fee-Details-Container p-6">
      <h1 className="text-xl font-bold mb-4">Edit Task</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <label className="block font-medium">Task Name</label>
            <input
              type="text"
              name="title"
              value={formData.title || ""}
              onChange={handleChange}
              className="border p-2 rounded w-full"
              placeholder="Enter task title"
              required
            />
          </div>
          <div className="flex-1">
            <label className="block font-medium">Task Description</label>
            <textarea
              name="description"
              value={formData.description || ""}
              onChange={handleChange}
              className="border p-2 rounded w-full"
              rows="2"
              placeholder="Enter task details"
            ></textarea>
          </div>
          <div className="flex-1">
            <label className="block font-medium">Task Deadline</label>
            <input
              type="datetime-local"
              name="deadline"
              value={formData.deadline || ""}
              onChange={handleChange}
              className="border p-2 rounded w-full"
              required
            />
          </div>

          
        </div>

   
    
        
    <div className="p-6 rounded-md shadow-sm bg-white space-y-4">
      <h2 className="text-lg font-semibold">Assign Employees with Priority</h2>

      
      {entries.map((entry, index) => (
        <div
          className="flex flex-col md:flex-row gap-4 items-center  p-3 rounded-lg"
          key={entry.id}
        >
          
          <div className="flex-1 w-full">
            <label className="block font-medium mb-1">Select Department</label>
            <select
              className="border p-2 rounded w-full"
              value={entry.department}
              onChange={(e) => updateEntry(entry.id, "department", e.target.value)}
              required
            >
              <option value="">-- Select Department --</option>
              {departments.map((dept) => (
                <option key={dept.dept_id} value={dept.dept_id}>
                  {dept.dept_name}
                </option>
              ))}
            </select>
          </div>

          
          <div className="flex-1 w-full">
            <label className="block font-medium mb-1">Select Employee</label>
            <select
              className="border p-2 rounded w-full"
              value={entry.employee}
              onChange={(e) => updateEntry(entry.id, "employee", e.target.value)}
              required
              disabled={!entry.department} 
            >
              <option value="">-- Select Employee --</option>
              {entry.department &&
                departments
                  .find((dept) => dept.dept_id == entry.department)
                  ?.employees.map((emp) => (
                    <option key={emp.emp_id} value={emp.emp_id}>
                      {emp.emp_name}
                    </option>
                  ))}
            </select>
          </div>

          
          <div className="flex-1 w-full">
            <label className="block font-medium mb-1">Priority</label>
            <select
              className="border p-2 rounded w-full"
              value={entry.priority}
              onChange={(e) => updateEntry(entry.id, "priority", e.target.value)}
              required
            >
              <option value="">-- Select Priority --</option>
              <option value="High">High</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Low">Low</option>
            </select>
          </div>

          
          <div className="flex items-center justify-center mt-4">
            <button
              type="button"
              onClick={() => removeEntry(entry.id)}
              className="bg-red-100 text-red-600 px-3 py-1 rounded hover:bg-red-200"
            >
              −
            </button>
          </div>
        </div>
      ))}

      
      <div className="mt-2">
        <button
          type="button"
          onClick={addEntry}
          className="bg-blue-100 text-blue-600 px-4 py-2 rounded hover:bg-blue-200"
        >
          + New Employee
        </button>
      </div>

      
    </div>
    <div className="flex flex-col md:flex-row gap-4">
      
      <div className="flex-1">
        <label className="block font-medium">Meeting Link</label>
          <input
              type="url"
              name="link"
              value={formData.link || ""}
              onChange={handleChange}
              className="border p-2 rounded w-full"
              placeholder="https://meeting.com/"
            />
      </div>
    </div>

    <div>
      <label className="block font-medium">Upload Files</label>
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        ref={fileInputRef}
        className="border p-2 rounded w-full"
      />

  
      {formData.files && formData.files.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-4">
          {Array.from(formData.files).map((file, index) => {
            
            const isImage = file.type.startsWith("image/");
            return (
              <div key={index} className="w-20 h-20 border rounded overflow-hidden relative">
                {isImage ? (
                  <img
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="flex items-center justify-center w-full h-full text-xs text-gray-500 text-center p-1">
                    {file.name}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {formData.files.length > 0 && (
        <p className="text-sm text-gray-600 mt-1">{formData.files.length} file(s) selected</p>
      )}
    </div>

    {status && <p className="mt-2 text-blue-600">{status}</p>}
    <button
      type="submit"
      className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
      disabled={submitStatus}
    >
      {submitStatus ? "Save......" : "Save Task"}
    </button>
  </form>
    </div>
  );
};

export default TaskEdit;
